// Exposed to router
import Home from './Home'

export default {
  Home
}